import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { WallBuilderProvider } from '../state';
import { wallBuilderInputsSlice } from '../state';
import MainStore from '@components/Shared/State/store';
import WallBuilder from './WallBuilder';
/**
 * WallBuilderApp component that wraps WallBuilder with Redux state management
 * This is the main component that should be used in the application
 */
const WallBuilderApp = () => {
    // Inject the wall builder inputs slice into the main Redux store
    useEffect(() => {
        MainStore.injectReducer('wallBuilderInputs', wallBuilderInputsSlice);
    }, []);
    return (_jsx(WallBuilderProvider, { children: _jsx(WallBuilder, {}) }));
};
export default WallBuilderApp;
